import React, { forwardRef, useEffect } from 'react';
import Box from 'fe-design-base/atoms/Box';

import Loader from 'components/Loader';
import LoadingIndicator from 'components/LoadingIndicator';

import { cxHelpers } from 'util/className';
import { PRODUCT_AREAS, TRACK_ACTION_TYPES } from 'util/tracking_constants';
import { useTrackUx } from 'util/uxEvents';

const { cx, cxEl } = cxHelpers('MessageDrawerListView');

const BOX_STYLE = {
  height: `calc(100vh - 94px)`,
  overscrollBehavior: 'contain',
};

const MessageDrawerListView = (
  {
    trackEventAction,
    renderRow,
    dataSource,
    emptyState,
    footer,
    className,
    isLoading,
    isLoadingMore,
    eventCategory,
  },
  ref
) => {
  const trackUxEvent = useTrackUx({
    productArea: PRODUCT_AREAS.NAVIGATION,
    eventCategory,
  });

  useEffect(() => {
    if (trackEventAction) {
      trackUxEvent(trackEventAction, TRACK_ACTION_TYPES.VIEW);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const renderEmptyState = dataSource.size === 0 && emptyState;

  return (
    <>
      <Box
        className={`${cx()} ${className}`}
        style={BOX_STYLE}
        relative
        scrollY
        ref={ref}
      >
        <Loader
          isLoading={isLoading}
          className={cxEl(isLoading ? 'loading' : 'loaded')}
          centeredAbsolute
        >
          {renderEmptyState ? (
            emptyState
          ) : (
            <>
              {dataSource
                .map((item, index) => renderRow(item, index))
                .toArray()}

              {isLoadingMore && (
                <Box h={30} vcenter hcenter>
                  <LoadingIndicator
                    type="threeDots"
                    centered
                    className={cxEl('loading')}
                  />
                </Box>
              )}
            </>
          )}
        </Loader>
      </Box>

      {!renderEmptyState && footer}
    </>
  );
};

export default forwardRef(MessageDrawerListView);
